import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementPeerRecoveryGetRequest,
	ManagementPeerRecoveryGetResult,
	ManagementPeerRecoveryRequests,
	ManagementPeerRecoverySetRequest,
	ManagementPeerRecoverySetResult,
} from './peerRecoveryCommands';

export function handleManagementPeerRecoveryRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementPeerRecoveryRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementPeerRecoveryRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementPeerRecoveryGetRequest:
				await dispatch<ManagementPeerRecoveryGetResult>({
					type: ManagementPeerRecoveryGetResult,
					result: await frontApplet.management.peerRecovery.get(),
				});
				break;
			case ManagementPeerRecoverySetRequest:
				await frontApplet.management.peerRecovery.set(commandEvent.command.configuration);
				await dispatch<ManagementPeerRecoverySetResult>({
					type: ManagementPeerRecoverySetResult,
					result: {},
				});
				break;
			default:
		}
	});
}
